import React from 'react';
import PropTypes from 'prop-types';
import toLower from 'lodash/toLower';

import visa from './icons/dark/1.png';
import mastercard from './icons/dark/2.png';
import diners from './icons/dark/10.png';
import discover from './icons/dark/14.png';
import jcb from './icons/dark/16.png';
import amex from './icons/dark/22.png';

function getIcon(brand) {
  switch(toLower(brand)) {
    case 'visa':
      return visa;
    case 'mastercard':
      return mastercard;
    case 'diners':
      return diners;
    case 'amex':
      return amex;
    case 'jcb':
      return jcb;
    case 'discover':
      return discover;
    default:
      return null;
  }
}

const defaultStyle = {
  background: 'rgb(136, 136, 136)',
  borderRadius: '2px',
  display: 'block',
  width: '30px',
  height: '18px',
  color: 'rgba(255, 255, 255, 0.69)',
  margin: '0px',
  fontSize: '6px',
  textTransform: 'uppercase',
  textAlign: 'center',
};

const PaymentIcon = ({ style, className, brand = 'card' }) => {
  const iconSrc = getIcon(brand);
  if(!iconSrc) {
    return (
      <span style={{ ...defaultStyle, ...style }}>
        <span style = {{
            display: 'block',
            width: 8,
            height: 4,
            borderRadius: 1,
            background: 'rgba(255,255,255,0.7)',
            position: 'relative',
            top: 5,
            left: 17
          }}
        />
      </span>
    )
  }
  return (
    <img
      src={iconSrc}
      style={{ ...defaultStyle, ...style }}
      className={className}
      alt={`${brand} payment icon`}
    />
  );
}

PaymentIcon.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  brand: PropTypes.string.isRequired,
};

PaymentIcon.defaultProps = {
  style: {},
  className: '',
  brand: null,
};

export default PaymentIcon;
